export default "__VITE_ASSET__37c66803__"